import Swal from "sweetalert2";
import {
  GetFinancialRecordDto,
  CreateFinancialRecordDto,
  FilterFichaFinanceiraDto,
  UpdateStatusImpressaoDto,
  UpdateStatusRemessaDto,
  CreateManyInLoteFichaFinanceiraDto,
} from "../shared/dtos/FichaFinanceira.dto";
import api from "./api";
import { ApiResponse } from "../shared/dtos/Caixa.dto";
import { StatusImpressaoEnum, StatusRemessaBaixaEnum, StatusRemessaEnum } from "../shared/enum/fichaFinanceira.enum";
import { TypeRemessa } from "../shared/enum/remessas.enum";
import { FormaPagamentoDto } from "../shared/dtos/FormaPagamento.dto";
import { ResultDto } from "../shared/dtos/Result.dto";
import { ResponseSearchFastFichaFinanceira } from "../shared/dtos/ReponseFastSearch.dto";
import { GetRetornoDto } from "../shared/dtos/Retorno.dto";
import { StatusRetorno } from "../shared/enum/retorno.enum";

// Interface para a resposta específica de criação de parcelas
interface CreateParcelasResponse extends ApiResponse {
  success: boolean;
  message: string;
}

class FichaFinanceiraService {
  static async searchParcela(
    idContribuinte: number,
    page: number,
    limit: number,
    search = ""
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    try {
      const response = await api.get(
        `ficha-financeira/findAllByContribuinte/${idContribuinte}`,
        {
          params: { page, limit, search }, // Passa os parâmetros corretamente
        }
      );


      return response.data as { data: GetFinancialRecordDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar parcelas:", error);
      return { data: [], total: 0 };
    }
  }

  static async getRecibo(id: number): Promise<any | null> {
    try {
      const response = await api.get(`ficha-financeira/get-recibo/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar recibo:", error);
      throw error;
    }
  }

  static async cadastrarParcela(
    parcelas: CreateFinancialRecordDto[],
    idContribuinte: number
  ): Promise<void> {
    try {
      // Faz a requisição, tipando a resposta como CreateParcelasResponse
      const response = await api.post<CreateParcelasResponse>(
        `ficha-financeira/cadastrar/${idContribuinte}`,
        parcelas,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 0,
        }
      );

      // Sucesso - Exibe a mensagem de sucesso que vem do backend
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: response.data.message || "Parcelas cadastradas com sucesso!",
          allowOutsideClick: false,
        });
      } else {
        // Erro - Exibe a mensagem de erro do backend
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            response.data.message ||
            "Ocorreu um erro ao cadastrar as parcelas!",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao cadastrar parcelas:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao tentar cadastrar as parcelas. Tente novamente.",
        allowOutsideClick: false,
      });
    }
  }

  static async cadastrarVariasParcelas(params: {
    contribuintes: { id: number; nome: string }[];
    parcelas: [{}];
  }): Promise<ResultDto> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        "ficha-financeira/cadastrar-varias",
        params,
        {
          timeout: 0,
        }
      );

      // Retornando a resposta completa do backend (com status)
      return response.data;
    } catch (error) {
      // Tratamento de erro
      console.error("Erro ao cadastrar parcelas:", error);
      throw error; // Lançar erro para que o frontend possa tratá-lo também
    }
  }

  static async cadastrarVariasParcelasEmLote(params: {
    contribuintes: { id: number; nome: string }[];
    parcelas: [{}];
  }): Promise<any> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        "ficha-financeira/cadastrar-lote",
        params,
        {
          timeout: 0,
        }
      );

      // Retornando a resposta completa do backend (com status)
      return response.data;
    } catch (error) {
      // Tratamento de erro
      console.error("Erro ao cadastrar parcelas:", error);
      throw error; // Lançar erro para que o frontend possa tratá-lo também
    }
  }

  static async cadastrarParcelasTodosContribuintesEmLote(data: {
    parcelas: [{}];
    params: {
      dateInitial: string;
      dateFinal: string;
      idLotacao?: number;
      idLocalPagamento?: number;
    }
  }): Promise<ResultDto> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        "ficha-financeira/cadastrar-lote-all-contribuintes",
        data,
        {
          timeout: 0,
        }
      );

      // Retornando a resposta completa do backend (com status)
      return response.data;
    } catch (error) {
      // Tratamento de erro
      console.error("Erro ao cadastrar parcelas:", error);
      throw error; // Lançar erro para que o frontend possa tratá-lo também
    }
  }

  // static async searchParcelaByData(params: {
  //   nossoNumero?: number;
  //   valorParcela?: number;
  // }): Promise<GetFinancialRecordDto[]> {
  //   try {
  //     const response = await api.get('ficha-financeira/parcela-buscada', { params });
  //     return response.data as GetFinancialRecordDto[];
  //   } catch (error) {
  //     console.error('Erro ao buscar parcelas por dados:', error);
  //     return [];
  //   }
  // }

  // static async filterParcela(
  //   idContribuinte: number,
  //   params: any,
  //   page: number = 1,
  //   limit: number = 12
  // ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
  //   try {
  //     // Remove valores undefined/null dos parâmetros
  //     const cleanParams = Object.fromEntries(
  //       Object.entries(params).filter(([_, v]) => v != null && v !== "")
  //     );

  //     const response = await api.get<GetFinancialRecordDto[]>(
  //       `ficha-financeira/filtro-aplicado/${idContribuinte}`,
  //       {
  //         params: cleanParams,
  //       }
  //     );
  //     // Obter o total de registros, geralmente no cabeçalho ou no corpo da resposta
  //     const total = parseInt(response.headers["x-total-count"]) || response.data.length;

  //     // Aplicar paginação no frontend
  //     const startIndex = (page - 1) * limit;
  //     const endIndex = startIndex + limit;
  //     const paginatedData = response.data ? response.data.slice(startIndex, endIndex) : [];

  //     return { data: paginatedData, total };
  //   } catch (error: any) {
  //     console.error("Erro detalhado ao filtrar parcelas:", {
  //       message: error.message,
  //       response: error.response?.data,
  //       status: error.response?.status,
  //       request: error.config,
  //       headers: error.response?.headers,
  //     });
  //     throw error;
  //   }
  // }

  static async filterParcela(
    idContribuinte: number,
    filter: FilterFichaFinanceiraDto,
    page: number,
    take: number
  ): Promise<{ fichas: GetFinancialRecordDto[]; total: number }> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        `ficha-financeira/filter-and-search/${idContribuinte}/${page}/${take}`,
        filter,
        {
          timeout: 0,
        }
      );

      return response.data as {
        fichas: GetFinancialRecordDto[];
        total: number;
      };
    } catch (error) {
      // Tratamento de erro
      console.error("Erro ao cadastrar parcelas:", error);
      throw error; // Lançar erro para que o frontend possa tratá-lo também
    }
  }

  static async getByContribuinteAndFilter(
    idContribuinte: number,
    filter: FilterFichaFinanceiraDto,
    page: number,
    take: number
  ): Promise<{ fichas: GetFinancialRecordDto[]; total: number }> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        `ficha-financeira/get-by-filter-and-contribuinte/${idContribuinte}/${page}/${take}`,
        filter,
        {
          timeout: 0,
        }
      );

      return response.data as {
        fichas: GetFinancialRecordDto[];
        total: number;
      };
    } catch (error) {
      // Tratamento de erro
      console.error("Erro ao cadastrar parcelas:", error);
      throw error; // Lançar erro para que o frontend possa tratá-lo também
    }
  }

  static async filterParcelaByRemittance(
    idRemittance: number,
    filter: FilterFichaFinanceiraDto,
    page: number,
    take: number
  ): Promise<{ fichas: GetFinancialRecordDto[]; total: number }> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        `ficha-financeira/filter-and-search-by-remittance/${idRemittance}/${page}/${take}`,
        filter,
        {
          timeout: 0,
        }
      );

      return response.data as {
        fichas: GetFinancialRecordDto[];
        total: number;
      };
    } catch (error: any) {
      // Tratamento de erro melhorado
      console.error("Erro ao filtrar parcelas por remessa:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        filter,
        idRemittance,
        page,
        take,
      });

      // Retorna um objeto vazio em vez de lançar o erro
      return {
        fichas: [],
        total: 0,
      };
    }
  }

  static async filterParcelaByRemittanceReturn(
    idRemittanceReturn: number,
    filter: FilterFichaFinanceiraDto,
    page: number,
    take: number
  ): Promise<{ fichas: GetFinancialRecordDto[]; total: number }> {
    try {
      // Enviando os parâmetros para o backend
      const response = await api.post(
        `ficha-financeira/filter-and-search-by-remittance-return/${idRemittanceReturn}/${page}/${take}`,
        filter,
        {
          timeout: 0,
        }
      );

      return response.data as {
        fichas: GetFinancialRecordDto[];
        total: number;
      };
    } catch (error) {
      // Tratamento de erro
      console.error("Erro ao cadastrar parcelas:", error);
      throw error; // Lançar erro para que o frontend possa tratá-lo também
    }
  }

  static async manualClearance(
    installments: { id: number; installmentValue: number }[],
    paidValue: number,
    dateValue: string,
    formaPagamento: FormaPagamentoDto,
    totalValue: number
  ): Promise<any> {
    try {
      // Garante que todos os valores são números com 2 casas decimais
      const formattedInstallments = installments.map((item) => ({
        id: Number(item.id),
        installmentValue: Number(Number(item.installmentValue).toFixed(2)),
      }));

      // Formata a data atual para o formato ISO sem milissegundos
      const currentDate = new Date(dateValue);
      const paymentDate = currentDate.toISOString().split(".")[0] + "Z";

      const payload = {
        installments: formattedInstallments,
        paidValue: Number(Number(paidValue).toFixed(2)),
        totalValue: Number(Number(totalValue).toFixed(2)),
        dataPagamento: paymentDate,
        formaPagamento,
      };

      const response = await api.post("ficha-financeira/baixa-manual", payload);
      if (!response.data) {
        throw new Error("Resposta vazia do servidor");
      }

      return response.data;
    } catch (error: any) {
      console.error("Erro ao realizar baixa manual:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        payload: error.config?.data,
      });
      throw error;
    }
  }

  static async getManualPayments(): Promise<GetFinancialRecordDto[]> {
    try {
      const response = await api.get<GetFinancialRecordDto[]>(
        "ficha-financeira/baixas-manuais"
      );

      if (!response.data) {
        throw new Error("Resposta vazia do servidor");
      }

      // Ordena os pagamentos por data de pagamento (mais recente primeiro)
      const sortedPayments = response.data.sort((a, b) => {
        const dateA = a.dataPagamento ? new Date(a.dataPagamento).getTime() : 0;
        const dateB = b.dataPagamento ? new Date(b.dataPagamento).getTime() : 0;
        return dateB - dateA;
      });

      return sortedPayments;
    } catch (error: any) {
      console.error("Erro ao buscar pagamentos manuais:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });

      // Tenta extrair a mensagem mais específica do erro
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Não foi possível carregar os pagamentos manuais.";

      throw new Error(errorMessage);
    }
  }

  static async getManualPaymentsByPeriod(data: {
    dateInitial: Date;
    dateFinal: Date;
    idLotacao?: number;
  }): Promise<ResultDto> {
    try {
      const response = await api.post<ResultDto>("ficha-financeira/get-manual-payments-by-period", {
        data,
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data) {
        throw new Error("Resposta vazia do servidor");
      }
      return response.data;
    } catch (error: any) {
      console.error("Erro ao buscar pagamentos manuais:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw new Error(
        "Não foi possível carregar os pagamentos manuais do período."
      );
    }
  }

  static async cancelInstallments(
    installmentsId: number[],
    tipoExclusaoId: number
  ): Promise<any> {
    try {
      const response = await api.post(
        "ficha-financeira/cancelamento-de-parcelas",
        {
          installmentsId,
          tipoExclusaoId,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao cancelar parcelas:", error);
    }
  }
  // src/services/FichaFinanceiraService.ts
  static async getManualPaymentsByPage(
    page: number,
    limit: number
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    try {
      const response = await api.get<{
        data: GetFinancialRecordDto[];
        total: number;
      }>("ficha-financeira/manual-payments", {
        params: { page, limit },
      });

      if (!response.data) {
        throw new Error("Resposta vazia do servidor");
      }

      return response.data;
    } catch (error: any) {
      console.error("Erro ao buscar pagamentos manuais:", error);
      throw error;
    }
  }

  static async update(idFichaFinanceira: number, data: any): Promise<any> {
    try {
      const response = await api.patch(
        `ficha-financeira/update/${idFichaFinanceira}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar ficha financeira:", error);
      throw error;
    }
  }

  static async updateStatusImpressaoMany(
    data: UpdateStatusImpressaoDto
  ): Promise<any> {
    try {
      const response = await api.patch(
        `ficha-financeira/update-impressao-many`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar ficha financeira:", error);
      throw error;
    }
  }


  static async updateStatusRemessaMany(
    data: UpdateStatusRemessaDto
  ): Promise<any> {
    try {
      const response = await api.patch(
        `ficha-financeira/update-remessa-many`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar ficha financeira:", error);
      throw error;
    }
  }

  static async getPdfToPrint(id: number): Promise<any> {
    try {
      const response = await api.get(`ficha-financeira/get-PDF/${id}`, {
        responseType: "blob",
        timeout: 0,
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao gerar PDF da ficha financeira:", error);
      throw error;
    }
  }

  static async createRemittanceMass(data: {
    idLocalPagamento: number;
    dateInitial?: string;
    dateFinal?: string;
    idLotacao?: number;
  }): Promise<ResultDto> {
    try {
      const response = await api.post(
        `ficha-financeira/create-remittance-mass`,
        {
          data,
          timeout: 0,
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas de boletos das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async createBillRemittanceMass(limit: number): Promise<any> {
    try {
      const response = await api.get(
        `ficha-financeira/create-bill-remittance/${limit}`,
        {
          timeout: 0,
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas de boletos das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async createAutomaticDebitMass(limit: number): Promise<any> {
    try {
      const response = await api.get(
        `ficha-financeira/create-automatic-debit-remittance/${limit}`,
        {
          timeout: 0,
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas de debitos automaticos das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async countParcelasByStatusRemessaAndLocalPagamento(data: {
    status: StatusRemessaEnum;
    // typeRemessa: TypeRemessa,
    idLocalPagamento: number;
    dateInitial: Date;
    dateFinal: Date;
    idLotacao?: number;
  }): Promise<any> {
    try {
      const response = await api.post(
        `ficha-financeira/count/status-remessa-and-local-pagamento`,
        {
          data,
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async countParcelasByStatusRemessaBaixaAndLocalPagamento(data: {
    status: StatusRemessaBaixaEnum;
    idLocalPagamento: number;
  }): Promise<any> {
    try {
      const response = await api.post(
        `ficha-financeira/count/status-remessa-baixa-and-local-pagamento`,
        {
          data,
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async getAllByRemittance(
    idRemessa: number,
    page: number,
    take: number
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    try {
      const response = await api.get(
        `ficha-financeira/get-by-remittance/${idRemessa}/${page}/${take}`
      );

      return response.data as { data: GetFinancialRecordDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar parcelas:", error);
      return { data: [], total: 0 };
    }
  }

  static async getAllByRemittanceReturn(
    idRemessaRetorno: number,
    page: number,
    take: number
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    try {
      const response = await api.get(
        `ficha-financeira/get-by-remittance-return/${idRemessaRetorno}/${page}/${take}`
      );

      return response.data as { data: GetFinancialRecordDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar parcelas:", error);
      return { data: [], total: 0 };
    }
  }

  static async findByRemittanceAndSearch(
    idRemessa: number,
    search: string,
    page: number,
    take: number
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    try {
      const response = await api.get(
        `ficha-financeira/get-by-remittance-search/${idRemessa}/${search}/${page}/${take}`
      );

      return response.data as { data: GetFinancialRecordDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar parcelas:", error);
      return { data: [], total: 0 };
    }
  }

  static async findByRemittanceAndFilter(
    idRemessa: number,
    params: any,
    page: number,
    take: number
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    // Alterado o tipo de retorno
    try {
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v != null && v !== "")
      );

      const response = await api.get<{
        data: GetFinancialRecordDto[];
        total: number;
      }>(
        `ficha-financeira/get-by-remittance-filter/${idRemessa}/${page}/${take}`,
        {
          params: cleanParams,
        }
      );

      // Remover a paginação no frontend - já é feita no backend
      return {
        data: response.data.data,
        total: response.data.total,
      };
    } catch (error: any) {
      console.error("Erro detalhado ao filtrar parcelas:", error);
      throw error;
    }
  }

  static async createBillOfPay(data: {
    idFichaFinanceira: number[];
  }): Promise<ResultDto> {
    try {
      const response = await api.post(`ficha-financeira/create-bill-of-pay`, {
        data,
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error: any) {
      console.error("Erro ao criar boletos de pagamento:", error);
      throw error;
    }
  }

  static async createBillOfPayLocalPagamentoAndLotacao(data: {
    dateInitial: Date;
    dateFinal: Date;
    fileName: string;
    idLocalPagamento?: number;
    idLotacao?: number;
  }): Promise<ResultDto> {
    try {
      const response = await api.post(
        `ficha-financeira/create-bill-of-pay-by-local-pagamento-and-lotacao`,
        data,
        {
          timeout: 0,
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async checkFileInPdfs(fileName: string): Promise<ResultDto> {
    try {
      const response = await api.get(
        `ficha-financeira/check-file-in-pdfs/${fileName}`,
        {
          timeout: 0,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Erro ao verificar arquivo PDF:", error);
      throw error;
    }
  }

  static async countBillOfPayLocalPagamentoAndLotacao(data: {
    dateInitial: Date;
    dateFinal: Date;
    idLocalPagamento?: number;
    idLotacao?: number;
  }): Promise<number> {
    try {
      const response = await api.post(
        `ficha-financeira/count-bill-of-pay-by-local-pagamento-and-lotacao`,
        {
          data,
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async updateStatusImpressaoByLocalPagamentoAndLotacao(data: {
    dateInitial: Date,
    dateFinal: Date,
    status: StatusImpressaoEnum,
    idLocalPagamento?: number,
    idLotacao?: number,
  }): Promise<ResultDto> {
    try {
      const response = await api.post(
        `ficha-financeira/update-impressao-by-local-pagamento-and-lotacao`,
        data,
        {
          timeout: 0,

        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao gerar arquivo de Remessas das fichas financeiras:",
        error
      );
      throw error;
    }
  }

  static async deleteFileInPdfs(fileName: string): Promise<ResultDto> {
    try {
      const response = await api.get(
        `ficha-financeira/delete-file-in-pdfs/${fileName}`,
        {
          timeout: 0,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Erro ao deletar arquivo PDF:", error);
      throw error;
    }
  }

  static async deleteManyFileInPdfs(fileNames: string[]): Promise<ResultDto> {
    try {
      const response = await api.post(
        `ficha-financeira/delete-many-file-in-pdfs`,
        fileNames,
        {
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Erro ao deletar arquivos PDF:", error);
      throw error;
    }
  }

  static async uploadFileRemessaRetornoSicredi(file: File): Promise<ResultDto> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post<ResultDto>(
      `/ficha-financeira/upload-remessa-retorno`,
      formData,
      {
        timeout: 0,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  static async getContribuinteSearchFast(search: string): Promise<{
    fichaFinanceiraNossoNumero: ResponseSearchFastFichaFinanceira;
    fichaFinanceiraNumeroDocumento: ResponseSearchFastFichaFinanceira;
    fichaFinanceiraLinhaDigitavel: ResponseSearchFastFichaFinanceira;
    fichaFinanceiraCodBarras: ResponseSearchFastFichaFinanceira;
  }> {
    const response = await api.get(
      `/ficha-financeira/get-contribuinte-for-search-fast/${search}`
    );
    return response.data;
  }

  static async getFichasFinanceirasSearchFast(
    id: number,
    page: number,
    take: number,
    completa: boolean,
    pagas: boolean
  ): Promise<{ data: GetFinancialRecordDto[]; total: number }> {
    const data = {
      page,
      take,
      completa,
      pagas,
    };
    const response = await api.post(
      `/ficha-financeira/get-fichas-financeiras-for-search-fast/${id}`,
      {
        data,
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  }

  static async ReversalManualClearance(id: number): Promise<ResultDto> {
    try {
      const response = await api.get(
        `ficha-financeira/reversal-manual-clearance/${id}`,
        {
          timeout: 0,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Erro ao estornar parcela:", error);
      throw error;
    }
  }
}

export default FichaFinanceiraService;
